import { environment } from '@env/environment';
import { URLSegment } from '@shared/enums/url-segment.enum';

export class ApiConstant {
  static URL_BASE = environment.base_url + environment.api_version + environment.api_prefix;
  static URL_BASE_v2 = environment.base_url + environment.api_v2 + environment.api_prefix;
  static REFRESH_TOKEN = ApiConstant.URL_BASE + URLSegment.Auth + 'refresh-access-token';
  static LOGIN = ApiConstant.URL_BASE + URLSegment.Auth + 'login';
  static CHANGE_PASSWORD = ApiConstant.URL_BASE + URLSegment.Auth + 'change-password';
  static VERIFY_EMAIL = ApiConstant.URL_BASE + URLSegment.Auth + 'verify-email';
  static REGISTER_DEVICE = ApiConstant.URL_BASE + URLSegment.Auth + 'register-device';
  static RESET_PASSWORD = ApiConstant.URL_BASE + URLSegment.Auth + 'reset-password';
  static SET_NEW_PASSWORD = ApiConstant.URL_BASE + URLSegment.Auth + 'set-new-password';
  static SET_TEMP_PASSWORD = ApiConstant.URL_BASE + URLSegment.Auth + 'set-temp-password';
  static GET_ALL_USERS = ApiConstant.URL_BASE + URLSegment.User + 'users';
  static GET_ALL_COUNTRIES = ApiConstant.URL_BASE + URLSegment.Shared + 'countries';
  static GET_ALL_INSURANCE_COMPANIES =
    ApiConstant.URL_BASE + URLSegment.Shared + 'insurance-companies';
  static GET_ALL_INSURANCE_COVERS = ApiConstant.URL_BASE + URLSegment.Shared + 'insurance-covers';
  static GET_ACTIVE_ROLES = ApiConstant.URL_BASE + URLSegment.Role + 'active-roles';
  static GET_USER_BY_ID = ApiConstant.URL_BASE + URLSegment.User;
  static ADD_USER = ApiConstant.URL_BASE + URLSegment.User + 'add';
  static ADD_CUSTOMER = ApiConstant.URL_BASE + URLSegment.Customer + 'add';
  static UPLOAD_MEDIA = ApiConstant.URL_BASE_v2 + 'media';
  static GET_MEDIA_BY_ID = ApiConstant.URL_BASE_v2 + 'media/';
  static UPDATE_USER = ApiConstant.URL_BASE + URLSegment.User + 'update';
  static ADD_EDIT_PARAMS = ApiConstant.URL_BASE + URLSegment.User + 'config/add-edit-params';
  static GET_USER_PARAMS = ApiConstant.URL_BASE + URLSegment.User + 'config/params';
  static HIDE_PRICE = ApiConstant.URL_BASE + URLSegment.User + 'update-hide-price';
  static ACTIVATE_AND_RESET_PASSWORD =
    ApiConstant.URL_BASE + URLSegment.Auth + 'activate-reset-password';
  static FORGET_PASSWORD = ApiConstant.URL_BASE + URLSegment.Auth + 'forget-password';
  static FORGET_PASSWORD_VERIFY_MOBILE =
    ApiConstant.URL_BASE + URLSegment.Auth + 'forget-password-verify-mobile';
  static REQUEST_OTP = ApiConstant.URL_BASE + URLSegment.Auth + 'request-otp';

  static GET_OPS_SCORE = ApiConstant.URL_BASE + URLSegment.Shipment + 'performance-ops-card';

  static GET_TRANSACTION_HISTORY =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'transaction-changes';

  static SAVE_INITIAL_ASSIGNMENT = ApiConstant.URL_BASE + URLSegment.AssignmentRequest;
  static GET_TRUCK_FOR_SAM = ApiConstant.URL_BASE + URLSegment.Truck + 'trucks-for-sam';

  static UPDATE_EXPECTED_DELIVERY_DATE =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'update-expected-delivery-date';
  // Notification
  static NOTIFICATIONS = ApiConstant.URL_BASE + URLSegment.Shared + 'notifications';
  static UNREAD_NOTIFICATION_COUNT =
    ApiConstant.URL_BASE + URLSegment.Shared + 'unread-notifications-count';
  static MARK_NOTIFICATIONS_AS_READ =
    ApiConstant.URL_BASE + URLSegment.Shared + 'mark-notifications-as-read';

  // Payment
  static API_INIT_PAYMENT = ApiConstant.URL_BASE + URLSegment.Payment + 'init-payment';
  static API_CHECK_TRANSACTION = ApiConstant.URL_BASE + URLSegment.Payment + 'check-transaction';
  static API_CHECK_PAYOUT_STATUS =
    ApiConstant.URL_BASE + URLSegment.Payment + 'check-payout-status';
  static CREATE_VIRTUAL_IBAN = ApiConstant.URL_BASE + URLSegment.Payment + 'viban';
  static PAY_FROM_WALLET = ApiConstant.URL_BASE + URLSegment.Payment + 'pay-from-wallet';

  // Announcement
  static GET_ANNOUNCEMENT = ApiConstant.URL_BASE + URLSegment.Announcement;
  static SET_ANNOUNCEMENT = ApiConstant.URL_BASE + URLSegment.Announcement + 'add';
  // Customers
  static GET_ALL_CUSTOMERS = ApiConstant.URL_BASE + URLSegment.Customer + 'customers';
  static GET_ALL_CUSTOMERS_WITH_PAGINATION =
    ApiConstant.URL_BASE + URLSegment.Customer + 'customers-with-pagination';
  static GET_CUSTOMER_BY_ID = ApiConstant.URL_BASE + URLSegment.Customer;
  static UPDATE_CUSTOMER = ApiConstant.URL_BASE + URLSegment.Customer + 'update';
  static GET_ALL_PRODUCT_TYPES = ApiConstant.URL_BASE + URLSegment.ProductType + 'product-types';
  static ADD_PRODUCT_TYPES = ApiConstant.URL_BASE + URLSegment.ProductType + 'add';
  static ADD_UPDATE_PRODUCT_TYPE = ApiConstant.URL_BASE + URLSegment.ProductType + 'add';
  static GET_PRODUCT_TYPE_ITEMS = ApiConstant.URL_BASE + URLSegment.Shared + 'lookups/PRODUCT_ITEM';
  static UPDATE_PRODUCT_TYPES = ApiConstant.URL_BASE + URLSegment.ProductType + 'update';
  static GET_PRODUCT_BY_ID = ApiConstant.URL_BASE + URLSegment.ProductType;
  static CUSTOMER_FLEETS = ApiConstant.URL_BASE + URLSegment.Customer + 'customer-fleets';
  static GET_CUSTOMERS_WITHOUT_ORGANIZATION =
    ApiConstant.URL_BASE + URLSegment.Customer + 'customers-without-organization';
  static UPDATE_CUSTOMER_SHOW_TRUCK_TYPES =
    ApiConstant.URL_BASE + URLSegment.Customer + 'update-customer-show-truck-types';
  static REJECT_CUSTOMER_REQUEST =
    ApiConstant.URL_BASE + URLSegment.Customer + 'reject-customer-request';
  static UPDATE_CUSTOMER_ETA = ApiConstant.URL_BASE + URLSegment.Customer + 'update-customer-eta';
  static GET_CUSTOMER_OPERATION_CONFIG =
    ApiConstant.URL_BASE + URLSegment.Customer + 'operation-config';
  static UPDATE_CUSTOMER_OPERATION_CONFIG =
    ApiConstant.URL_BASE + URLSegment.Customer + 'update-operation-configuration';
  static UPDATE_CUSTOMER_FLEETS_CAN_ASSIGN_SHIPMENTS =
    ApiConstant.URL_BASE + URLSegment.Customer + 'update-fleet-new-shipments';
  static GET_FLEETS_CAN_PICK_NEW_SHIPMENTS =
    ApiConstant.URL_BASE + URLSegment.Customer + 'list-new-shipment-fleets';
  static CUSTOMER_EMAIL_CONFIG = ApiConstant.URL_BASE + URLSegment.Customer + 'email-config';
  static CUSTOMER_UPDATE_EMAIL_CONFIG =
    ApiConstant.URL_BASE + URLSegment.Customer + 'updateemail-config';
  static ADD_LOCATION_CUSTOMER =
    ApiConstant.URL_BASE + URLSegment.Customer + 'add-location-customer';
  static GET_MY_CUSTOMERS = ApiConstant.URL_BASE + URLSegment.Customer + 'my-customers';
  static UPDATE_R_CUSTOMERS = ApiConstant.URL_BASE + URLSegment.Customer + 'update-R-customers';
  static CUSTOMER_LOCATIONS = ApiConstant.URL_BASE + URLSegment.Customer + 'location';
  static UPDATE_CREATION_TEMPLATE =
    ApiConstant.URL_BASE + URLSegment.Customer + 'update-creation-template';
  static GET_CREATION_TEMPLATE = ApiConstant.URL_BASE + URLSegment.Customer + 'creation-template';
  static GET_GEOFENCING_CONFIG =
    ApiConstant.URL_BASE + URLSegment.Customer + 'fleet-geofencing-config';
  static ADD_GEOFENCING_CONFIG =
    ApiConstant.URL_BASE + URLSegment.Customer + 'fleet-geofencing-config';
  static GET_DYNAMICS_INTEGRATION =
    ApiConstant.URL_BASE + URLSegment.Customer + 'integration-configrations';
  static UPDATE_DYNAMICS_INTEGRATION =
    ApiConstant.URL_BASE + URLSegment.Customer + 'integration-configrations';
  static SEND_DIRECT_SMS = ApiConstant.URL_BASE + URLSegment.Customer + 'sms';
  static UPDATE_CUSTOMER_DYNAMIC_BOARD =
    ApiConstant.URL_BASE + URLSegment.Customer + 'update-dynamic-board';
  static GET_CUSTOMER_DASHBOARD_CONFIGURATIONS =
    ApiConstant.URL_BASE + URLSegment.Customer + 'dashboard-configurations';

  //dispatching
  static GET_CUSTOMER_DISPATCH_Config = ApiConstant.URL_BASE + URLSegment.CustomerDispatch + 'config/';
  static UPDATE_CUSTOMER_DISPATCH_CONFIG = ApiConstant.URL_BASE + URLSegment.CustomerDispatch + 'update-config/';  

  static GET_CUSTOMERS_SHIP_AND_RECEIVE =
    ApiConstant.URL_BASE + URLSegment.CustomerDashboard + 'get-customers-ship-and-receive';
  static GET_CUSTOMERS_AND_CONTRACTS_COUNTS =
    ApiConstant.URL_BASE + URLSegment.CustomerDashboard + 'get-customers-and-contracts-counts';

  static GET_TOP_TEN_CUSTOMER =
    ApiConstant.URL_BASE + URLSegment.CustomerDashboard + 'get-top-ten-customers';

  static GET_CUSTOMER_TRANSACTIONS = ApiConstant.URL_BASE + URLSegment.WCC + 'transactions';

  static GET_CUSTOMER_OVERDUE_CONFIG =
    ApiConstant.URL_BASE + URLSegment.Customer + 'financial-config/';
  static UPDATE_CUSTOMER_OVERDUE_CONFIG =
    ApiConstant.URL_BASE + URLSegment.Customer + 'financial-config/';
  static GET_CUSTOMER_OVERDUE_SUMMARY =
    ApiConstant.URL_BASE + URLSegment.Customer + 'financial-summary/';

  static GET_CUSTOMER_DYNAMIC_FIELDS_CONFIG =
    ApiConstant.URL_BASE + 'customer-dynamic-fields-config/' + URLSegment.Customer;
  static UPDATE_CUSTOMER_DYNAMIC_FIELDS_CONFIG =
    ApiConstant.URL_BASE + 'customer-dynamic-fields-config';

  static GET_WALLET_SUMMARY = ApiConstant.URL_BASE + URLSegment.Wallet + 'wallets';
  static GET_WALLET_TRANSACTIONS =
    ApiConstant.URL_BASE + URLSegment.Wallet + 'customer-transactions';
  static UPDATE_CUSTOMER_OVERDRAFT_LIMIT =
    ApiConstant.URL_BASE + URLSegment.Wallet + 'set-overdraft-limit';
  static GET_VIRTUAL_IBAN = ApiConstant.URL_BASE + URLSegment.Customer + 'viban';
  // Invoices
  static GET_FLEET_WITHDRAW_LIST = ApiConstant.URL_BASE + URLSegment.FleetWithdrawalRequest;
  static GET_FLEET_WITHDRAW_COUNTS =
    ApiConstant.URL_BASE + URLSegment.FleetWithdrawalRequest + 'counts';
  static API_GET_INVOICES = ApiConstant.URL_BASE + URLSegment.Invoice + 'invoices';
  static API_GET_INVOICES_COUNTS = ApiConstant.URL_BASE + URLSegment.Invoice + 'counts';
  static API_EXPORT_ALL_INVOICES =
    ApiConstant.URL_BASE + URLSegment.Invoice + 'export-all-invoices';
  static GET_CUSTOMER_INVOICES = ApiConstant.URL_BASE + URLSegment.Invoice + 'invoices';
  static REJECT_INVOICE = ApiConstant.URL_BASE + URLSegment.Invoice + 'reject';
  static DASHBOARD_STATUS_COUNT = ApiConstant.URL_BASE + URLSegment.Invoice + 'dashboard';
  static PARTIAL_INVOICE_STATUS_COUNT =
    ApiConstant.URL_BASE + URLSegment.PartialInvoice + 'dashboard';
  static GET_PAYTABS_DETAILS = ApiConstant.URL_BASE + 'payment/batch-transaction-details';
  static MANUALLY_RUN_OVERDUE =
    ApiConstant.URL_BASE + URLSegment.Invoice + 'manually-run-overdue-and-deduction-cronJob';

  static MARK_PAID = ApiConstant.URL_BASE + URLSegment.Invoice + 'mark-as-paid';
  static MARK_UN_PAID = ApiConstant.URL_BASE + URLSegment.Invoice + 'mark-as-unpaid';
  static DELETE_DRAFT = ApiConstant.URL_BASE + URLSegment.Invoice + 'delete-invoice/';

  static ADD_INVOICE = ApiConstant.URL_BASE + URLSegment.Invoice + 'add';
  static UPDATE_INVOICE_DATE = ApiConstant.URL_BASE + URLSegment.Invoice + 'update-invoice-date';
  static UPDATE_INVOICE = ApiConstant.URL_BASE + URLSegment.Invoice + 'update';
  static EXPORT_INVOICE_PDF = ApiConstant.URL_BASE + URLSegment.Invoice + 'export-invoice-pdf';
  static UPDATE_INVOICE_ACTUAL_PAYMENT_DATE =
    ApiConstant.URL_BASE + URLSegment.Invoice + 'edit-actual-payment-date-invoice';
  static UPDATE_INVOICE_ATTACHMENTS =
    ApiConstant.URL_BASE + URLSegment.Invoice + 'update/attachments';

  static FLEET_PAYMENT_DETAILS =
    ApiConstant.URL_BASE + URLSegment.Payment + 'fleet-payment-details';
  static REQUEST_EMAIL_OTP = ApiConstant.URL_BASE + URLSegment.Auth + 'request-email-otp';
  static FLEET_PAY = ApiConstant.URL_BASE + URLSegment.Payment + 'fleet-pay';

  static GET_CUSTOMERS_PERFORMANCE =
    ApiConstant.URL_BASE + URLSegment.Customer + 'customer-performance';
  static REFRESH_CUSTOMERS_PERFORMANCE =
    ApiConstant.URL_BASE + URLSegment.Customer + 'refresh-customer-performance';
  static EDIT_SHIPMENTS_DRAFT_INVOICE =
    ApiConstant.URL_BASE + URLSegment.Invoice + 'edit-shipments-draft-invoice';
  static CREATE_INVOICE = ApiConstant.URL_BASE + URLSegment.Invoice + 'add';
  static GET_FLEET_DELIVERY_NOTES =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'fleet-delivery-notes';

  static GET_SHIPMENT_ORDER_ROUTE = ApiConstant.URL_BASE + 'shipment-orders-route';

  static RENTED_TRUCKS_INVOICING =
    ApiConstant.URL_BASE + URLSegment.Truck + 'rented-trucks-invoicing';
  static GET_RENTED_TRUCKS_ShIPMENTS =
    ApiConstant.URL_BASE + URLSegment.Truck + 'rented-trucks-shipments-invoicing';

  static API_GET_INVOICES_ACTIVITY_STATUS = ApiConstant.URL_BASE + URLSegment.InvoiceHistory;
  static CREATE_PARTIAL_PAYMENT = ApiConstant.URL_BASE + URLSegment.PartialInvoice + 'save';
  static GET_PARTIALLY_PAYMENT_HISTORY =
    ApiConstant.URL_BASE + URLSegment.PartialInvoice.replace(/\/$/, '');
  static REJECT_PARTIALLY_PAYMENT =
    ApiConstant.URL_BASE + URLSegment.PartialInvoice + 'mark-as-rejected';
  static PAID_PARTIALLY_PAYMENT = ApiConstant.URL_BASE + URLSegment.PartialInvoice + 'mark-as-paid';

  // Delivery Notes
  static GET_INVOICE_DELIVERY_NOTES =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'invoice-delivery-notes';
  static GET_EXPORT_DELIVERY_NOTE =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'invoice-delivery-notes-export';
  static GET_EXPORT_INVOICE_PDF = ApiConstant.URL_BASE + URLSegment.Invoice + 'export-invoice-pdf';
  static GET_PARTIAL_INVOICE = ApiConstant.URL_BASE + URLSegment.PartialInvoice;
  static GET_PARTIAL_INVOICE_DETAILS = ApiConstant.URL_BASE + URLSegment.PartialInvoice + 'details';
  static UPDATE_DELIVERY_NOTE_VERIFICATION_STATUS =
    ApiConstant.URL_BASE + URLSegment.DeliveryNote + 'verification-status';

  // Receivers
  static GET_ALL_RECEIVERS = ApiConstant.URL_BASE + URLSegment.Receiver + 'receivers';
  static GET_PAGINATED_RECEIVERS =
    ApiConstant.URL_BASE + URLSegment.Receiver + 'receivers-with-pagination';
  static ADD_RECEIVER = ApiConstant.URL_BASE + URLSegment.Receiver + 'add';
  static GET_RECEIVER_BY_ID = ApiConstant.URL_BASE + URLSegment.Receiver;
  static UPDATE_RECEIVER = ApiConstant.URL_BASE + URLSegment.Receiver + 'update';
  static API_EXPORT_RECEIVERS =
    ApiConstant.URL_BASE + URLSegment.Receiver + 'export-receivers-excel';

  // Location
  static ADD_LOCATION = ApiConstant.URL_BASE + URLSegment.Shared + 'location/add';
  static EDIT_LOCATION = ApiConstant.URL_BASE + URLSegment.Shared + 'location/update';
  static LOCATION_GET_ALL = ApiConstant.URL_BASE + URLSegment.Shared + 'active-locations';
  static GET_LOCATION_DETAILS = ApiConstant.URL_BASE + URLSegment.Shared + 'location';
  static GET_LEAD_DRIVERS_LOCATIONS = ApiConstant.URL_BASE + URLSegment.Lead + 'leads';
  static API_GET_WCC_REGIONS = ApiConstant.URL_BASE + URLSegment.WCC + 'regions';
  static API_GET_WCC_RECEIVERS = ApiConstant.URL_BASE + URLSegment.WCC + 'receivers';

  // Fleet Provider
  static GET_ALL_FLEETS = ApiConstant.URL_BASE + URLSegment.Fleet + 'fleets';
  static GET_ALL_FLEETS_B2C = ApiConstant.URL_BASE + URLSegment.Fleet + 'b2c-fleets';
  static ADD_FLEET = ApiConstant.URL_BASE + URLSegment.Fleet + 'add';
  static GET_FLEET_BY_ID = ApiConstant.URL_BASE + 'fleet';
  static UPDATE_FLEET = ApiConstant.URL_BASE + URLSegment.Fleet + 'update';
  static GET_ACTIVE_FLEETS = ApiConstant.URL_BASE + URLSegment.Fleet + 'active-fleets';
  static VERIFY_FLEET = ApiConstant.URL_BASE + URLSegment.Fleet + 'verify';
  static GET_FLEET_B2C_CONFIG = ApiConstant.URL_BASE + URLSegment.Fleet + 'get-b2c-fleet-config';
  static ADD_FLEET_B2C_CONFIG = ApiConstant.URL_BASE + URLSegment.Fleet + 'add-b2c-fleet-config';
  static GET_SPECIFIC_FLEET = ApiConstant.URL_BASE + URLSegment.Fleet + 'specific-fleets';
  static GET_SPECIFIC_FLEET_WITHOUT_CONTRACT =
    ApiConstant.URL_BASE + URLSegment.Fleet + 'specific-fleets-without-contracts';
  static VALID_FLEETS_TO_MOVE =
    ApiConstant.URL_BASE + URLSegment.Fleet + 'valid-fleets-to-transfer';
  static GET_ACTIVE_FLEETSB2C = ApiConstant.URL_BASE + URLSegment.Fleet + 'active-fleets';
  static GET_ACTIVE_FLEETS_WITH_PAYMENTS =
    ApiConstant.URL_BASE + URLSegment.Fleet + 'active-fleets/payments';
  static UPDATE_FLEET_CONFIG = ApiConstant.URL_BASE + URLSegment.Fleet + 'fleet-config';
  static GET_ATHR_DRIVER = ApiConstant.URL_BASE + URLSegment.Athr + 'driver';
  static UPDATE_ATHR_DRIVER = ApiConstant.URL_BASE + URLSegment.Driver + 'update-driver-by-athr';
  static GET_ATHR_FLEET = ApiConstant.URL_BASE + URLSegment.Athr + 'fleet';
  static UPDATE_ATHR_FLEET = ApiConstant.URL_BASE + URLSegment.Fleet + 'update-fleet-by-athr';
  static GET_ATHR_TRUCK = ApiConstant.URL_BASE + URLSegment.Athr + 'truck';
  static UPDATE_ATHR_TRUCK = ApiConstant.URL_BASE + URLSegment.Truck + 'update-truck-by-athr';
  static CHANGE_TRUCK_OPERATION_STATUS =
    ApiConstant.URL_BASE + URLSegment.Truck + 'operation-status';
  static GET_CLASSIFIED_TRADELANES = ApiConstant.URL_BASE + 'truck-area-preference';

  static GET_FLEETS_CLASSIFICATION_COUNTS =
    ApiConstant.URL_BASE + URLSegment.FleetDashboard + 'get-fleets-classification-counts';
  static GET_FLEETS_TRUCKS_DRIVERS_COUNTS =
    ApiConstant.URL_BASE + URLSegment.FleetDashboard + 'get-fleets-trucks-drivers-counts';
  static GET_GLOBAL_AND_SPECIFIC_FLEETS_AND_CONTRACTS_COUNTS =
    ApiConstant.URL_BASE +
    URLSegment.FleetDashboard +
    'get-global-and-specific-fleets-and-contracts-counts';
  static GET_TOP_TEN_FLEETS =
    ApiConstant.URL_BASE + URLSegment.FleetDashboard + 'get-top-ten-fleets';

  static API_ORDERS_UPLOADED = ApiConstant.URL_BASE + URLSegment.Order + 'upload-orders';
  static API_BULK_UPLOADED_ORDERS = environment.exportShipmentUrl;
  static GET_FLEET_PROVIDERS_LEADS =
    ApiConstant.URL_BASE + URLSegment.Fleet + 'mobile-created-fleets';
  static GET_FLEET_PROVIDERS_LEADS_COUNT =
    ApiConstant.URL_BASE + URLSegment.Fleet + 'mobile-fleet-counts';
  static UPDATE_FLEET_STATUS = ApiConstant.URL_BASE + URLSegment.Fleet + 'update-status';
  static GET_LEAD_LOGS = ApiConstant.URL_BASE + URLSegment.Fleet + 'activity-logs';

  // Assinging logs
  static GET_ASSIGNMENT_LOGS = ApiConstant.URL_BASE + URLSegment.AssingingLogs + 'logs';

  // Backhaul Shipments
  static GET_BACKHAUL_TRUCKS = ApiConstant.URL_BASE + URLSegment.Backhaul + 'available-trucks';
  static GET_BACKHAULING_SHIPMENTS =
    ApiConstant.URL_BASE + URLSegment.Backhaul + 'available-shipments';
  static BOOK_BACKHAUL_SHIPMENT = ApiConstant.URL_BASE + URLSegment.Backhaul + 'book';

  // Shipments
  static GET_SHIPMENT_BY_ID = ApiConstant.URL_BASE + URLSegment.Shipment;
  static GET_SHIPMENT_SUMMARY_BY_ID = (id: string) =>
    ApiConstant.URL_BASE + URLSegment.Shipment + id + '/summary';
  static GET_SHIPMENT_TRACKING_BY_ID = (id: string) =>
    ApiConstant.URL_BASE + URLSegment.Shipment + id + '/tracking';
  static GET_SHIPMENT_REQUESTS_BY_ID = (id: string) =>
    ApiConstant.URL_BASE + URLSegment.Shipment + id + '/requests';
  static GET_SHIPMENT_FINANCIAL_BY_ID = (id: string) =>
    ApiConstant.URL_BASE + URLSegment.Shipment + id + '/financial';
  static GET_SHIPMENT_DELIVERY_NOTE_BY_ID = ApiConstant.URL_BASE + URLSegment.DeliveryNotes;
  static ASSIGN_FLEET = ApiConstant.URL_BASE + URLSegment.Shipment + 'assign';
  static ASSIGN_FLEETB2C = ApiConstant.URL_BASE + URLSegment.Shipment + 'b2c-assign';
  static GET_ALL_SHIPMENTS = ApiConstant.URL_BASE + URLSegment.Shipment + 'shipments';
  static GET_ALL_SHIPMENTS_COUNT = ApiConstant.URL_BASE + URLSegment.Shipment + 'shipments-count';
  static GET_ALL_B2C_SHIPMENTS = ApiConstant.URL_BASE + URLSegment.Shipment + 'b2c-shipments';
  static EDIT_B2C_SHIPMENT = ApiConstant.URL_BASE + URLSegment.Shipment + 'b2c-shipment-update';

  static EXPORT_B2C_SHIPMENTS = ApiConstant.URL_BASE + URLSegment.Shipment + 'export-b2c-shipments';
  static EXPORT_B2C_SHIPMENTS_EXCEED_LIMIT = environment.exportShipmentUrl + '/add-export-task';
  static SHIPMENT_ADD = ApiConstant.URL_BASE + URLSegment.Shipment + 'add/beta';
  static SHIPMENT_UPDATE = ApiConstant.URL_BASE + URLSegment.Shipment + 'update';
  static SHIPMENT_UPDATE_STATUS = ApiConstant.URL_BASE + URLSegment.Shipment + 'update/' + 'status';
  static UPDATE_BROADCAST_STATUS =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'update-broadcast-status';
  static GET_CUSTOMER_RATE = ApiConstant.URL_BASE + URLSegment.Contract + 'customer';
  static API_GET_SPOT_PRICES_RATE = ApiConstant.URL_BASE + URLSegment.Contract + 'spot-price';
  static GET_USER_PERFORMANCE = ApiConstant.URL_BASE + URLSegment.Shipment + 'user-performance';
  static GET_DELIVERY_NOTES = ApiConstant.URL_BASE + URLSegment.Shipment + 'delivery-notes';
  static GET_EXPORT_DELIVERY_NOTES =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'export-delivery-notes';
  static DELETE_SHIPMENT = ApiConstant.URL_BASE + URLSegment.Shipment;
  static RESEND_OTP = ApiConstant.URL_BASE + URLSegment.Shipment + 'resend-otp';
  static GET_TRANSPORTATION_PAYMENTS =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'transportation-payment';
  static UPDATE_TRANSPORTATION_PAYMENT =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'update-transportation-payment';
  static CREATE_TRANSPORTATION_PAYMENT =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'create-transportation-payment';
  static EXPORT_TRANSPORTATION_PAYMENT =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'export-transportation-payment';
  static DELETE_SHIPMENT_FROM_TRANSPORTATION_INVOICE =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'delete-shipment-from-transportation-invoice';
  static MARK_SHIPMENT_AS_PAID_FOR_DRIVER =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'mark-as-paid-for-driver';
  static GET_INVOICES_TRANSPORTATION =
    ApiConstant.URL_BASE + URLSegment.InvoiceTransportation + 'invoices-transportation';
  static DOWNLOAD_EWAYBILL =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'preview-shipment-ewaybill';
  static GET_B2C_SHIPMENT_BY_ID =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'b2c-shipment-detials';
  static GET_B2C_SHIPMENT_LOGS = ApiConstant.URL_BASE + URLSegment.Shipment + 'shipment-log/';
  static API_EXPORT_SHIPMENTS =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'export-shipments-list-csv';
  static GET_SHIPMENT_REQUESTS = ApiConstant.URL_BASE + URLSegment.Shipment + 'requests/';
  static GET_SHIPMENT_AVL_SUMMARY = ApiConstant.URL_BASE + URLSegment.Traccar + 'summary/';
  static CANCEL_B2C_SHIPMENT = ApiConstant.URL_BASE + URLSegment.Shipment + 'b2c-shipment-cancel';
  static DOWNLOAD_B2C_AIR_WAYBILL =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'b2c-shipment-waybill';

  static CHECK_B2C_CRON_JOB_STATUS =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'shipment-cron-by-id/';

  static SYNC_FLEET_STATUS = ApiConstant.URL_BASE + URLSegment.Integration + 'sync-fleet-status';
  static BULK_SYNC_FLEET_STATUS =
    ApiConstant.URL_BASE + URLSegment.Integration + 'sync-fleet-status-bulk';

  static UPLOAD_PROOF_OF_DELIVERY = ApiConstant.URL_BASE + URLSegment.Shipment + 'upload-pod';

  static NOTIFY_VENDOR = ApiConstant.URL_BASE + URLSegment.Providers + 'status/update';
  static MANUALLY_UPDATE_STATUS =
    ApiConstant.URL_BASE + URLSegment.Integration + 'b2c-update-status';

  static BULK_CANCEL_SHIPMENTS =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'b2c-shipment-cancel-bulk';

  static BULK_CANCEL_INTEGRATION =
    ApiConstant.URL_BASE + URLSegment.Integration + 'b2c-shipment-cancel-integration-bulk';

  static BULK_PICKED_BY_CONSUMER =
    ApiConstant.URL_BASE + URLSegment.Integration + 'b2c-picked-by-consumer-bulk';

  static BULK_NOTIFY_VENDOR = ApiConstant.URL_BASE + URLSegment.Providers + 'status/update/bulk';

  static BULK_REASSIGN_SHIPMENTS = ApiConstant.URL_BASE + URLSegment.Shipment + 'b2c-bulk-assign';
  static BULK_EDIT_ZONE = ApiConstant.URL_BASE + URLSegment.Shipment + 'b2c-shipment-update-bulk';
  static GENERATE_B2C_PDF =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'b2c-shipment-generate-pdf-and-trigger/';
  static MARK_SHIPMENT_DELIVERED = ApiConstant.URL_BASE + URLSegment.Shipment + 'mark-as-received/';
  static PRINT_BAYAN_TRIP = ApiConstant.URL_BASE + URLSegment.Shipment + 'print-bayan-trip';
  static BAYAN_INTEGRATE_TRIP = ApiConstant.URL_BASE + URLSegment.Shipment + 'create-bayan-trip';
  static BAYAN_CANCEL_WAYBILL = ApiConstant.URL_BASE + URLSegment.Shipment + 'cancel-bayan-waybill';
  static GET_RUNNING_SHIPMENTS = ApiConstant.URL_BASE + URLSegment.Shipment + 'running-shipments/';
  static GET_SHIPMENT_INFO_COUNTS =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'shipment-info-counts';
  static EXPORT_SHIPMENTS_PAYMENT =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'export-transportation-payment-excel';
  static GET_LIVE_TRACKING_SHIPMENTS_LIST =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'live-tracking-shipments';
  static GET_DISTRIBUTE_FLEET = ApiConstant.URL_BASE + URLSegment.DistributeFleet;
  static DISTRIBUTE_SELECTED_FLEETS =
    ApiConstant.URL_BASE + URLSegment.DistributeFleet + 'distribute-selected-fleets';
  static GET_FLEETS_LIST = ApiConstant.URL_BASE + URLSegment.DistributeFleet + 'list';

  static GET_DELIVERY_NOTE = ApiConstant.URL_BASE + URLSegment.DeliveryNote;
  static CHECK_DN_HARD_COPY =
    ApiConstant.URL_BASE + URLSegment.DeliveryNote + 'check-dn-hard-copy-exist';

  static BULK_ASSIGN_SHIPMENTS = ApiConstant.URL_BASE + URLSegment.Shipment + 'bulk-assign';

  // integrations
  static GET_SHIPMENT_INTEGRATIONS = ApiConstant.URL_BASE + URLSegment.Integration + 'shipments';
  static GET_B2C_SHIPMENT_INTEGRATIONS =
    ApiConstant.URL_BASE + URLSegment.Integration + 'b2c-integration-box';
  static GET_FLEET_DYNAMIC_INTEGRATION = ApiConstant.URL_BASE + URLSegment.Fleet + 'integrations';
  static INTEGRATE_SHIPMENT = ApiConstant.URL_BASE + URLSegment.Integration + 'integrate';
  static FLEET_INTEGRATE_SHIPMENT =
    ApiConstant.URL_BASE + URLSegment.Integration + 'fleet-integrate';

  static EXPORT_TRANSPORTATION_PAYMENTS =
    ApiConstant.URL_BASE + URLSegment.InvoiceTransportation + 'export-invoices-transportation';
  static UPDATE_GATE_TO_GATE_TIME = ApiConstant.URL_BASE + URLSegment.Shipment + 'history/update';
  static GET_SHIPMENT_HISTORY_ITEM = ApiConstant.URL_BASE + URLSegment.Shipment + 'history/';
  static GET_SHIPMENT_DOOR_OPEN_HISTORY =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'door-open-history';
  static GET_TEMPERATURE_AND_HUMIDITY = ApiConstant.URL_BASE + URLSegment.Shipment + 'alerts/';

  // Geofencing
  static GET_GEOFENCING_SHIPMENT_UPDATES =
    ApiConstant.URL_BASE + URLSegment.Geofencing + 'geofencing-updates/';

  // Requests
  static UPDATE_TRAILER_LABEL = ApiConstant.URL_BASE + URLSegment.Request + 'update/trailer-label';

  // Trucks
  static GET_SHIPMENT_PATH =
    environment.socket_url +
    environment.api_version +
    environment.api_prefix +
    URLSegment.ShipmentLocation;
  static GET_SHIPMENT_AVL_PATH = ApiConstant.URL_BASE + URLSegment.Traccar + 'shipments/';
  static GET_TRUCK_CUSTOM_REPORT = ApiConstant.URL_BASE + URLSegment.Traccar + 'custom-report';
  static GET_AVL_GROUPS = ApiConstant.URL_BASE + URLSegment.Traccar + 'groups';
  static GET_TRUCK_SHIPMENTS = ApiConstant.URL_BASE + URLSegment.Truck + 'truck-shipment/';
  static GET_RENTED_TRUCK_DASHBOARD =
    ApiConstant.URL_BASE + URLSegment.Truck + 'rented-trucks-dashboard';

  // Truck Types
  static TRUCK_GET_ACTIVE = ApiConstant.URL_BASE + URLSegment.TruckType + 'active-truck-types';
  static GET_ACTIVE_TRUCK_TYPES_CONTRACT_CUSTOMER =
    ApiConstant.URL_BASE + URLSegment.TruckType + 'active-truck-types-contract-customer';

  // Trucks
  static GET_ALL_TRUCKS = ApiConstant.URL_BASE + URLSegment.Truck + 'trucks';
  static GET_FLEET_ACTIVE_TRUCKS = ApiConstant.URL_BASE + URLSegment.Truck + 'active-trucks';
  static CALCULATE_TRUCK_DISTANCE =
    ApiConstant.URL_BASE + URLSegment.Truck + 'calculate-trucks-distance';
  static GET_ALL_BRANDS = ApiConstant.URL_BASE + URLSegment.Brand + 'brands';
  static ADD_TRUCK = ApiConstant.URL_BASE + URLSegment.Truck + 'add';
  static GET_TRUCK_BY_ID = ApiConstant.URL_BASE + URLSegment.Truck;
  static CREATE_TRUCK_AREA_PREFERENCE =
    ApiConstant.URL_BASE + URLSegment.TruckAreaPreference + 'add';
  static UPDATE_TRUCK_AREA_PREFERENCE =
    ApiConstant.URL_BASE + URLSegment.TruckAreaPreference + 'update';
  static DELETE_TRUCK_AREA_PREFERENCE =
    ApiConstant.URL_BASE + URLSegment.TruckAreaPreference + 'delete/';
  static UPDATE_TRUCK = ApiConstant.URL_BASE + URLSegment.Truck + 'update';
  static INTEGRATE_FLEET_WITH_3LEM = ApiConstant.URL_BASE + URLSegment.Elm + URLSegment.Vehicle;
  static ADD_BULK_TRUCKS = ApiConstant.URL_BASE + URLSegment.Truck + 'add-bulk-trucks';
  static CHECK_BULK_TRUCKS = ApiConstant.URL_BASE + URLSegment.Truck + 'check-bulk-trucks';
  static GET_TRUCK_BY_AVL_ID = ApiConstant.URL_BASE + URLSegment.Truck;
  static GET_FLEET_TRUCKS_PLANNING =
    ApiConstant.URL_BASE + URLSegment.Truck + 'fleet-trucks-planing';
  static RELEASE_TRUCK = ApiConstant.URL_BASE + URLSegment.Truck + 'release';
  static GET_TRUCK_LOCATION = ApiConstant.URL_BASE + URLSegment.Truck + 'truck-location';
  static TRUCK_STATUS_CALENDAR = ApiConstant.URL_BASE + URLSegment.Truck + 'calendar';
  static TRUCK_OPERATION_STATUS = ApiConstant.URL_BASE + URLSegment.Truck + 'operation-status';
  static OPERATION_STATUS_EXPORT =
    ApiConstant.URL_BASE + URLSegment.Truck + 'operation-status-export';
  static VERIFY_TRUCK_BY_3LEM = ApiConstant.URL_BASE + URLSegment.Truck + 'verify-truck-by-elm';
  static TRUCKS_PERFORMANCE = ApiConstant.URL_BASE + URLSegment.Truck + 'trucks-performance';
  static GET_TRUCKS_SHIPMENTS = ApiConstant.URL_BASE + URLSegment.Truck + 'trucks-shipments';
  static GET_TRUCK_PROFITS = ApiConstant.URL_BASE + URLSegment.RentedTrucksContracts + 'profits';
  static GET_TRUCK_NON_CONTRACT_DAYS =
    ApiConstant.URL_BASE + URLSegment.Truck + 'rented_trucks-shipments';
  static ADD_RENTED_TRUCK_CONTRACT =
    ApiConstant.URL_BASE + URLSegment.RentedTrucksContracts + 'add';
  static UPDATE_RENTED_TRUCK_CONTRACT =
    ApiConstant.URL_BASE + URLSegment.RentedTrucksContracts + 'update';
  static GET_RENTED_TRUCK_CONTRACT_BY_ID = ApiConstant.URL_BASE + URLSegment.RentedTrucksContracts;
  static GET_ALL_RENTED_TRUCK_CONTRACTS =
    ApiConstant.URL_BASE + URLSegment.RentedTrucksContracts + 'trucks-rented-contracts';
  static GET_TRUCKS_NON_CONTRACT_DAYS =
    ApiConstant.URL_BASE + URLSegment.RentedTrucksContracts + 'non-contracted-days';
  static GET_TRUCK_TEMPERATURE_LOG_PDF =
    ApiConstant.URL_BASE + URLSegment.Traccar + 'export-traccar-report';

  // Drivers
  static GET_ACTIVE_DRIVERS = ApiConstant.URL_BASE + URLSegment.Driver + 'active-drivers';
  static ADD_DRIVER = ApiConstant.URL_BASE + URLSegment.Driver + 'add';
  static GET_ALL_DRIVERS = ApiConstant.URL_BASE + URLSegment.Driver + 'drivers';
  static GET_DRIVER_BY_ID = ApiConstant.URL_BASE + URLSegment.Driver;
  static UPDATE_DRIVER = ApiConstant.URL_BASE + URLSegment.Driver + 'update';
  static INTEGRATE_WITH_3LEM = ApiConstant.URL_BASE + URLSegment.Elm + URLSegment.Driver;
  static VERIFY_BY_3LEM = ApiConstant.URL_BASE + URLSegment.Driver + 'verify-driver-by-elm';
  static SEND_PASSWORD = ApiConstant.URL_BASE + URLSegment.Driver + 'send-password';
  static GET_DRIVER_LOCATION =
    environment.socket_url +
    environment.api_version +
    environment.api_prefix +
    URLSegment.DriverLocation +
    'all';
  static GET_DRIVER_SHIPMENTS = ApiConstant.URL_BASE + URLSegment.Driver + 'driver-shipments/';
  static ADD_DRIVER_WITH_TRUCK = ApiConstant.URL_BASE + URLSegment.Driver + 'driver-with-truck';
  static DRIVER_MOVE_TO_FLEET = ApiConstant.URL_BASE + URLSegment.Driver + 'transfer-to-fleet';
  static FILTER_DRIVER_BY_FLEET_TYPE =
    ApiConstant.URL_BASE + URLSegment.Driver + 'filter-driver-by-fleet-type';
  static ADD_BULK_DRIVERS = ApiConstant.URL_BASE + URLSegment.Driver + 'add-bulk-drivers';
  static CHECK_BULK_DRIVERS = ApiConstant.URL_BASE + URLSegment.Driver + 'check-bulk-drivers';
  static ADD_BULK_DRIVERS_WITH_TRUCKS =
    ApiConstant.URL_BASE + URLSegment.Driver + 'add-bulk-trucks-with-drivers';
  static CHECK_BULK_DRIVERS_WITH_TRUCKS =
    ApiConstant.URL_BASE + URLSegment.Driver + 'check-bulk-trucks-with-drivers';
  static API_GET_EXPORT_DRIVERS = ApiConstant.URL_BASE + URLSegment.Driver + 'export-drivers-excel';
  static RELEASE_DRIVER = ApiConstant.URL_BASE + URLSegment.Driver + 'release';
  static UPDATE_DRIVER_BLACKLIST = ApiConstant.URL_BASE + 'driver-black-list/add';

  // Trailer
  static ADD_TRAILER = ApiConstant.URL_BASE + URLSegment.Trailer + 'add';
  static UPDATE_TRAILER = ApiConstant.URL_BASE + URLSegment.Trailer + 'update';
  static GET_ALL_FLEET_TRAILERS = ApiConstant.URL_BASE + URLSegment.Trailer + 'fleet-trailers';
  static GET_TRILER_BY_ID = ApiConstant.URL_BASE + URLSegment.Trailer;

  // Contract
  static GET_ALL_CONTRACTS = ApiConstant.URL_BASE + URLSegment.Contract + 'contracts';
  static GET_RELATED_CONTRACT = ApiConstant.URL_BASE + URLSegment.Contract + 'related-contract';
  static GET_CONTRACT = ApiConstant.URL_BASE + URLSegment.Contract;
  static GET_MATCHED_FLEETS = ApiConstant.URL_BASE + URLSegment.Contract + 'matched';
  static ADD_CONTRACT = ApiConstant.URL_BASE + URLSegment.Contract + 'add';
  static UPDATE_CONTRACT = ApiConstant.URL_BASE + URLSegment.Contract + 'update';
  static GET_GLOBAL_CONTRACT = ApiConstant.URL_BASE + URLSegment.Contract + 'global-contract';
  static ADD_TRADE_LANE = ApiConstant.URL_BASE + URLSegment.Contract + 'trade-lane/add';
  static UPDATE_TRADE_LANE = ApiConstant.URL_BASE + URLSegment.Contract + 'trade-lane/update';
  // --- Bulk shipment creation -------------------------------------------------
  // All scoped by `customerId` = the customer chosen in the page's selector.
  static BULK_SHIPMENTS_DRAFT = ApiConstant.URL_BASE + URLSegment.Shipment + 'bulk/draft';
  static BULK_SHIPMENTS_DRAFT_SYNC = ApiConstant.URL_BASE + URLSegment.Shipment + 'bulk/draft/sync';
  static BULK_SHIPMENTS_CREATE = ApiConstant.URL_BASE + URLSegment.Shipment + 'bulk/create';
  static BULK_SHIPMENTS_ROUTE_DEFAULTS = ApiConstant.URL_BASE + URLSegment.Shipment + 'bulk/route-defaults';
  static BULK_SHIPMENTS_LOCATIONS = ApiConstant.URL_BASE + URLSegment.Shipment + 'bulk/locations';
  static BULK_SHIPMENTS_COLUMNS = ApiConstant.URL_BASE + URLSegment.Shipment + 'bulk/columns';
  /** The customer's saved column mapping for sheet imports: GET reads it, POST replaces it. */
  static BULK_IMPORT_MAPPING = ApiConstant.URL_BASE + URLSegment.Shipment + 'bulk/import/mapping';
  /** Reads an uploaded sheet against that mapping and reports what it found. Creates nothing. */
  static BULK_IMPORT_VALIDATE = ApiConstant.URL_BASE + URLSegment.Shipment + 'bulk/import/validate';
  /** Creates the shipments for the valid rows of an already-validated batch. */
  static BULK_IMPORT_CONFIRM = ApiConstant.URL_BASE + URLSegment.Shipment + 'bulk/import/confirm';

  static GET_TRADE_LANE_PRICES = ApiConstant.URL_BASE + URLSegment.Contract + 'trade-lane/prices';

  // City
  static GET_ACTIVE_CITIES = ApiConstant.URL_BASE + URLSegment.City + 'active-cities';
  static GET_ALL_CITIES = ApiConstant.URL_BASE + URLSegment.City + 'cities';

  // Lead
  static GET_ALL_LEADS = ApiConstant.URL_BASE + URLSegment.Lead + 'leads';
  static GET_LEADS_COUNT = ApiConstant.URL_BASE + URLSegment.Lead + 'count';
  static UPDATE_LEAD_STATUS = (id: number) =>
    ApiConstant.URL_BASE + URLSegment.Lead + id + '/status';
  static DELETE_LEAD = ApiConstant.URL_BASE + URLSegment.Lead;

  //dashboard
  static GET_ORDER_STATUS = ApiConstant.URL_BASE + URLSegment.Dashboard + 'order-status';
  static GET_ORDER_FULFILLMENT = ApiConstant.URL_BASE + URLSegment.Dashboard + 'order-fulfillment';
  static GET_MADAR_PERFORMANCE = ApiConstant.URL_BASE + URLSegment.Dashboard + 'madar-performance';
  static GET_TOP_DRIVERS = ApiConstant.URL_BASE + URLSegment.Dashboard + 'top-drivers';
  static GET_OPERATION_PERFORMANCE =
    ApiConstant.URL_BASE + URLSegment.Dashboard + 'operation-performance';
  static EXPORT_OPERATION_PERFORMANCE =
    ApiConstant.URL_BASE + URLSegment.Dashboard + 'export-operation-performance';
  static GET_TOTAL_DELIVERY_NOTES =
    ApiConstant.URL_BASE + URLSegment.Dashboard + 'delivery-notes-counts';
  static GET_TOTAL_JOINED =
    ApiConstant.URL_BASE + URLSegment.Dashboard + 'joined-fleets-and-customers-counts';
  static GET_TOTAL_CONTRACTS = ApiConstant.URL_BASE + URLSegment.Dashboard + 'contracts-counts';
  static GET_TOTAL_DRIVERS_COUNTS = ApiConstant.URL_BASE + URLSegment.Dashboard + 'drivers-counts';
  static GET_TOTAL_TRUCKS_COUNTS = ApiConstant.URL_BASE + URLSegment.Dashboard + 'trucks-counts';
  static GET_ORDER_COUNT = ApiConstant.URL_BASE + URLSegment.Dashboard + 'order-count';
  static GET_ORDER_TRADE_LANE_COUNT =
    ApiConstant.URL_BASE + URLSegment.Dashboard + 'order-trade-lane-count';
  static GET_GROWTH_ANALYSIS = ApiConstant.URL_BASE + URLSegment.Dashboard + 'growth-analysis';

  // invoice
  static GET_INVOICE_STATUS = ApiConstant.URL_BASE + URLSegment.Invoice + 'count-and-amount';

  // Organizations
  static GET_ALL_ORGANIZATIONS = ApiConstant.URL_BASE + URLSegment.Organization + 'organizations';
  static ADD_ORGANIZATION = ApiConstant.URL_BASE + URLSegment.Organization + 'add';
  static GET_ORGANIZATION_BY_ID = ApiConstant.URL_BASE + URLSegment.Organization;
  static REMOVE_ORGANIZATION_BY_ID = ApiConstant.URL_BASE + URLSegment.Organization;
  static UPDATE_ORGANIZATION = ApiConstant.URL_BASE + URLSegment.Organization + 'update';
  static ADD_ORGANIZATION_CUSTOMERS =
    ApiConstant.URL_BASE + URLSegment.Organization + 'add-customers';
  static REMOVE_ORGANIZATION_CUSTOMERS =
    ApiConstant.URL_BASE + URLSegment.Organization + 'remove-customers';
  static UPDATE_ORGANIZATION_DYNAMIC_BOARD =
    ApiConstant.URL_BASE + URLSegment.Organization + 'update-dynamic-board';
  static GET_ORGANIZATION_DASHBOARD_CONFIGURATIONS =
    ApiConstant.URL_BASE + URLSegment.Organization + 'dashboard-configurations';
  static CHECK_YCC_USERS_VALIDATE = ApiConstant.URL_BASE + URLSegment.WCC + 'users-validate';
  // Reports
  static TRUCK_REPORT = ApiConstant.URL_BASE + URLSegment.Truck + 'truck-report';
  static TRUCK_REPORT_CSV = ApiConstant.URL_BASE + URLSegment.Truck + 'truck-report-csv';
  static DRIVER_REPORT = ApiConstant.URL_BASE + URLSegment.Driver + 'driver-report';
  static DRIVER_REPORT_CSV = ApiConstant.URL_BASE + URLSegment.Driver + 'driver-report-csv';
  static SHIPMENT_REPORT =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'shipment-consolidation-report';
  static SHIPMENT_REPORT_CSV =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'shipment-consolidation-report-csv';
  static GET_AVL_REPORT = ApiConstant.URL_BASE + URLSegment.Traccar + 'devices-report';
  static EXPORT_AVL_REPORT = ApiConstant.URL_BASE + URLSegment.Traccar + 'export-devices';
  static INTEGRATION_REPORT =
    ApiConstant.URL_BASE + URLSegment.Integration + 'integration-actions-report';
  static SHIPMENT_GATES_REPORT =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'shipment-gates-report';
  static TRUCK_UTILIZATION_REPORT =
    ApiConstant.URL_BASE + URLSegment.Truck + 'truck-report-utilization';

  // Sales Orders
  static GET_ALL_SALES_ORDERS = ApiConstant.URL_BASE + URLSegment.SalesOrder + 'list';
  static GET_SALES_ORDER_BY_ID = ApiConstant.URL_BASE + URLSegment.SalesOrder;

  static GET_ORDERS_PALLET_LIST = ApiConstant.URL_BASE + URLSegment.Pallet + 'orders-pallet-list';
  static GET_PLAN_TRUCKS = ApiConstant.URL_BASE + URLSegment.Truck + 'available-trucks';
  static CREATE_SHIPMENT_ORDER = ApiConstant.URL_BASE + URLSegment.Shipment + 'add/list';

  // Route Time
  static ADD_ROUTE_TIME = ApiConstant.URL_BASE + URLSegment.RouteTime + 'add';
  static GET_ROUTE_TIMES = ApiConstant.URL_BASE + URLSegment.RouteTime + 'route-times';
  static DELETE_TRUCK_TYPE_ROUTE_TIME = ApiConstant.URL_BASE + URLSegment.RouteTime;
  static UPDATE_ROUTE_TIME = ApiConstant.URL_BASE + URLSegment.RouteTime + 'update';

  // smart detection
  static DETECT_DRIVERS =
    environment.socket_url +
    environment.api_version +
    environment.api_prefix +
    URLSegment.DriverLocation +
    'nearest-drivers';

  // B2c Logs
  static GET_B2C_SHIPMENT_REQUESTS = ApiConstant.URL_BASE + URLSegment.Shipment + 'requests';

  // Rules
  static ADD_B2C_SHIPMENT_RULE = ApiConstant.URL_BASE + URLSegment.ShipmentRule + 'add';
  static GET_SHIPMENT_RULES = ApiConstant.URL_BASE + URLSegment.ShipmentRule;
  static GET_ZONES = ApiConstant.URL_BASE + URLSegment.ShipmentRule + 'zones';
  static GET_SHIPMENT_RULE = ApiConstant.URL_BASE + URLSegment.ShipmentRule;
  static UPDATE_B2C_SHIPMENT_RULE = ApiConstant.URL_BASE + URLSegment.ShipmentRule + 'update';

  //sellers
  static GET_ALL_SELLERS = ApiConstant.URL_BASE + URLSegment.Seller + 'sellers';
  static UPDATE_SELLERS_CONFIGURATION = ApiConstant.URL_BASE + URLSegment.Seller + 'direct-fleets';
  static GET_SELLERS_CONFIGURATION =
    ApiConstant.URL_BASE + URLSegment.Seller + 'direct-fleets-list';

  static UPDATE_SELLER_CONFIGURATION =
    ApiConstant.URL_BASE + URLSegment.Seller + 'direct-fleets-zone';
  // delivered orders
  static GET_DELIVERED_ORDERS = ApiConstant.URL_BASE + URLSegment.Shipment + 'get-delivered-orders';
  static GET_VENDOR_INVOICES =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'get-vendor-delivered-orders';
  static GET_FLEETS_SUBTOTAL = ApiConstant.URL_BASE + URLSegment.Shipment + 'get-fleets-subtotal';
  static GET_PRIMARY_CONFIGURATION = ApiConstant.URL_BASE + URLSegment.PrimaryConfiguration;
  static UPDATE_PRIMARY_CONFIGURATION = ApiConstant.URL_BASE + URLSegment.PrimaryConfiguration;

  //heat map
  static GET_HEAT_MAP_AREAS_ORDERS =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'heatmap-areas-orders';
  static GET_HEAT_MAP_AREAS_SELLERS =
    ApiConstant.URL_BASE + URLSegment.Seller + 'heatmap-areas-sellers';

  static GET_HEAT_MAP_AREAS_POLYGONS = ApiConstant.URL_BASE + URLSegment.HeatmapAreas;

  // measurements
  static GET_ALL_MEASUREMENT_UNITS =
    ApiConstant.URL_BASE + URLSegment.MeasurementUnit + 'measurement-units';

  // permits
  static UPDATE_DRIVER_PERMIT = ApiConstant.URL_BASE + URLSegment.Permits;
  static UPDATE_TRUCK_PERMIT = ApiConstant.URL_BASE + URLSegment.Permits + 'trucks/';

  static GET_LOOKUPS = ApiConstant.URL_BASE + URLSegment.Shared + 'lookups/';
  static GET_GLOBAL_SEARCH_LOOKUPS = ApiConstant.URL_BASE + URLSegment.Shared + 'search-any-where/';

  // avl & external devices & daleel tracking
  static GET_AVL_DEVICES = ApiConstant.URL_BASE + URLSegment.Traccar + 'devices';
  static GET_AVL_MOBILE_DEVICES = ApiConstant.URL_BASE + URLSegment.Traccar + 'mobile-devices';

  static GET_AVL_POSITIONS = ApiConstant.URL_BASE + URLSegment.Traccar + 'positions';
  static GET_AVL_MOBILE_POSITIONS = ApiConstant.URL_BASE + URLSegment.Traccar + 'mobile-positions';

  static GET_AVL_SHIPMENT_STOPS = ApiConstant.URL_BASE + URLSegment.Traccar + 'shipment-stops';
  static GET_AVL_EXTERNAL_DEVICES =
    ApiConstant.URL_BASE + URLSegment.ExternalTracking + 'devices/' + 'AFAQY';
  static GET_AVL_EXTERNAL_DEVICE_SUMMARY =
    ApiConstant.URL_BASE + URLSegment.ExternalTracking + 'device-summary/' + 'AFAQY';
  static GET_DALEEL_TRACKING = ApiConstant.URL_BASE + URLSegment.DaleelTracking;
  static GET_DALEEL_RUNNING_SHIPMENTS =
    ApiConstant.URL_BASE + URLSegment.DaleelTracking + 'get-all-daleel-positions';
  static GET_SHIPMENT_MOBILE_TRACKING_ACTIVITY_LOGS =
    ApiConstant.URL_BASE + URLSegment.Traccar + 'activity-logs/';

  // exception logs
  static GET_EXCEPTION_LOGS = ApiConstant.URL_BASE + URLSegment.Logs;

  // wcc Logs
  static GET_WCC_LOGS = ApiConstant.URL_BASE + URLSegment.Order + URLSegment.Logs;
  static RETRY_WCC_LOG = ApiConstant.URL_BASE + URLSegment.Order + 'retry-orders';

  // Customer Support
  static ADD_TICKET = ApiConstant.URL_BASE + URLSegment.CustomerSupport + URLSegment.Ticket + 'add';
  static UPLOAD_TICKET_MEDIA = ApiConstant.URL_BASE + URLSegment.CustomerSupport + 'ticket-upload';
  static GET_SUPPORT_TOKEN = ApiConstant.URL_BASE + URLSegment.CustomerSupport + 'token';
  static GET_TICKET = ApiConstant.URL_BASE + URLSegment.CustomerSupport + 'ticket';

  // Audit Trail
  static GET_AUDIT_TRAILS = ApiConstant.URL_BASE + 'audit-trails';

  static GET_TRIP_PERFORMANCES = ApiConstant.URL_BASE + URLSegment.TripPerformance + 'list';
  static GET_TRIP_PERFORMANCE = ApiConstant.URL_BASE + URLSegment.TripPerformance;
  static ADD_TRIP_PERFORMANCE = ApiConstant.URL_BASE + URLSegment.TripPerformance + 'add';
  static UPDATE_TRIP_PERFORMANCE = ApiConstant.URL_BASE + URLSegment.TripPerformance + 'update';
  static GET_FROM_TO_DISTANCE = ApiConstant.URL_BASE + URLSegment.Distance + 'calculate';

  // Smart Center
  static GET_SHIPMENTS_COUNT_STATUS =
    ApiConstant.URL_BASE + URLSegment.SmartCenter + 'shipments-count-status';
  static GET_OFFLINE_DEVICES_COUNT =
    ApiConstant.URL_BASE + URLSegment.SmartCenter + 'offline-devices';

  static SEND_WHATSAPP_ALERT =
    ApiConstant.URL_BASE + URLSegment.SmartCenter + 'send_whatsapp_alert';
  static GET_EWAYBILL_HEALTHY = ApiConstant.URL_BASE + URLSegment.SmartCenter + 'ewaybill-healthy';
  static GET_SHIPMENT_PERFORMANCE_SUMMARY =
    ApiConstant.URL_BASE + URLSegment.SmartCenter + 'shipment-performance-summary';

  static GET_FIX_SHIPMENT = ApiConstant.URL_BASE + URLSegment.SmartCenter + 'shipment-smart-fix';

  static WCC_GET_BALANCE = ApiConstant.URL_BASE + URLSegment.WCC + 'landing-balance';
  static WCC_GET_PRODUCTS = ApiConstant.URL_BASE + URLSegment.WCC + 'products';
  static WCC_GET_PRODUCT_PRICE = ApiConstant.URL_BASE + URLSegment.WCC + 'get-product-price';
  static WCC_GET_TIME_SLOTS = ApiConstant.URL_BASE + URLSegment.WCC + 'get-available-slots';
  static WCC_CREATE_SHIPMENT = ApiConstant.URL_BASE + URLSegment.Shipment + 'add/beta';
  static WCC_GET_DELIVERY_NOTE_LINE =
    ApiConstant.URL_BASE + URLSegment.WCC + 'get-delivery-note-line';
  static WCC_USERS_WITH_PARAMS = ApiConstant.URL_BASE + URLSegment.Customer + 'users-with-params';
  static WCC_GET_ORDER_LOGS = ApiConstant.URL_BASE + URLSegment.WCC + 'order-logs';
  static WCC_INTEGRATE_WITH_CEMENT = ApiConstant.URL_BASE + URLSegment.WCC + 'update-order';

  // Shipment Routing
  static SHIPMENT_ROUTING = ApiConstant.URL_BASE + URLSegment.ShipmentRouting;
  static SHIPMENT_ROUTING_INFO = ApiConstant.URL_BASE + URLSegment.ShipmentRouting + 'routing-info';

  static GET_USER_PREFERENCES = ApiConstant.URL_BASE + URLSegment.User + 'get_user_preferences';
  static UPDATE_USER_PREFERENCES =
    ApiConstant.URL_BASE + URLSegment.User + 'update_user_preferences';

  // Orders
  static API_GET_ORDER_LIST = ApiConstant.URL_BASE + URLSegment.Order + 'list';
  static API_GET_ORDERS_COUNT = ApiConstant.URL_BASE + URLSegment.Order + 'count';
  static API_GET_PALLET_LIST = ApiConstant.URL_BASE + URLSegment.Pallet + 'pallet-list';
  static GET_ORDERS_CUSTOMERS = ApiConstant.URL_BASE + URLSegment.Order + 'orders-customers/';
  static API_GET_UNDETAILED_ORDER_INFO =
    ApiConstant.URL_BASE + URLSegment.Order + 'order-line-items';
  static API_UPDATE_ORDERS_PRIORITY =
    ApiConstant.URL_BASE + URLSegment.Order + 'update-orders-priority';

  // Sales Orders
  static API_ADD_SALES_ORDER = ApiConstant.URL_BASE + URLSegment.SalesOrder + 'add';

  static GET_SHIPMENT_ASSIGNMENT_REQUESTS =
    ApiConstant.URL_BASE + URLSegment.AssignmentRequest + 'shipment-assignment-requests';

  static UPDATE_ASSIGNMENT_REQUEST_STATUS = ApiConstant.URL_BASE + URLSegment.AssignmentRequest;

  // Dispatch Activity
  static GET_SHIPMENT_DISPATCH_ACTIVITY = (id: string) =>
    ApiConstant.URL_BASE + URLSegment.Shipment + id + '/dispatch-events';

  // Waiting Charge
  static WAITING_CHARGE_LOGS = (id: number) => ApiConstant.URL_BASE + URLSegment.Shipments + id + `/${URLSegment.WaitingChargeLogs}`;
  static APPROVE_WAITING_CHARGE_LOGS = (id: number) => ApiConstant.URL_BASE + URLSegment.Shipments + id + `/${URLSegment.WaitingChargeLogs}approve`;

  // Release Notes
  static GET_RELEASE_NOTES = ApiConstant.URL_BASE + URLSegment.ReleaseNote + 'release-notes';
  static GET_RELEASE_NOTE = ApiConstant.URL_BASE + URLSegment.ReleaseNote;
  static ADD_RELEASE_NOTE = ApiConstant.URL_BASE + URLSegment.ReleaseNote + 'add';
  static UPDATE_RELEASE_NOTE = ApiConstant.URL_BASE + URLSegment.ReleaseNote + 'update';

  // Tour Guide
  static GET_TOUR_GUIDES = ApiConstant.URL_BASE + URLSegment.ReleaseNote + 'tour-guides';
  static TOUR_GUIDE_VISIT = ApiConstant.URL_BASE + URLSegment.ReleaseNote + 'tour-guide-visit';

  static CHECK_DUPLICATION_ORDER_NUMBER =
    ApiConstant.URL_BASE + URLSegment.Shipment + 'referance-validate';

  static CHECK_SELLERS = ApiConstant.URL_BASE + URLSegment.Seller + 'validate';

  static GET_DYNAMIC_DASHBOARDS = ApiConstant.URL_BASE + URLSegment.User + 'dashboards';
  static UPDATE_DYNAMIC_DASHBOARD =
    ApiConstant.URL_BASE + URLSegment.User + 'update_user_dashboards';
  static GET_DYNAMIC_DASHBOARD = ApiConstant.URL_BASE + URLSegment.User + 'dashboard-users';

  static API_GET_TABLEAU_TOKEN = ApiConstant.URL_BASE + 'shared/tableau-auth';

  // Online Booking
  static GET_ONLINE_BOOKING_LEADS = ApiConstant.URL_BASE + URLSegment.LeadRequest + 'lead-requests';
  static PAUSE_ONLINE_BOOKING_LEADS = ApiConstant.URL_BASE + URLSegment.LeadRequest + 'pause/';
  static GET_LEADS_NOTIFICATION_USERS =
    ApiConstant.URL_BASE + URLSegment.User + 'leads-notification-users';
  static CONVERT_LEADS = ApiConstant.URL_BASE + URLSegment.LeadRequest + 'convert';
  static GET_ONLINE_BOOKING_ALL_TRADE_LANES =
    ApiConstant.URL_BASE + URLSegment.OnlineBooking + 'all-trade-lanes';
  static CREATE_ONLINE_BOOKING_TRADE_LANE =
    ApiConstant.URL_BASE + URLSegment.OnlineBooking + 'create-trade-lane';
  static UPDATE_ONLINE_BOOKING_TRADE_LANE =
    ApiConstant.URL_BASE + URLSegment.OnlineBooking + 'trade-lane';
  static DELETE_ONLINE_BOOKING_TRADE_LANE =
    ApiConstant.URL_BASE + URLSegment.OnlineBooking + 'trade-lane';
  static GET_SPECIFIC_TRUCKS_ONLINE_BOOKING =
    ApiConstant.URL_BASE + URLSegment.OnlineBooking + 'get-specific-trucks-online-booking';

  static CHECK_CUSTOMER_EXISTENCE =
    ApiConstant.URL_BASE + URLSegment.Customer + 'check-customer-existence';
  // ai messages
  static API_SEND_AI_MESSAGE = ApiConstant.URL_BASE + 'ai-assistant/chat';

  static LOGOUT = ApiConstant.URL_BASE + URLSegment.Auth + 'logout';

  // Fleet Bids
  static GET_SHIPMENT_BIDS = ApiConstant.URL_BASE + URLSegment.FleetBid + URLSegment.Shipment;

  // Waiting Charge Config
  static WAITING_CHARGE_CONFIG_FLEET =
    ApiConstant.URL_BASE + URLSegment.WaitingChargeConfig + URLSegment.Fleet;
  static WAITING_CHARGE_CONFIG_CUSTOMER =
    ApiConstant.URL_BASE + URLSegment.WaitingChargeConfig + URLSegment.Customer;

  // Account Statement
  static GET_ACCOUNT_STATEMENT_CUSTOMER =
    ApiConstant.URL_BASE + URLSegment.AccountStatement + URLSegment.Customer;
  static GET_ACCOUNT_STATEMENT_FLEET =
    ApiConstant.URL_BASE + URLSegment.AccountStatement + URLSegment.Fleet;
  static GET_ACCOUNT_STATEMENT_CUSTOMER_COUNTS = (id: number) =>
    ApiConstant.URL_BASE + URLSegment.AccountStatement + URLSegment.Customer + id + '/counts';
  static GET_ACCOUNT_STATEMENT_FLEET_COUNTS = (id: number) =>
    ApiConstant.URL_BASE + URLSegment.AccountStatement + URLSegment.Fleet + id + '/counts';
}
